module.exports = {
	"data": {
		"postBySlug": {
			"html": "",
			"frontmatter": {
				"title": "First DMGT Doc"
			},
			"fields": {
				"slug": "/first-dmgt-doc"
			}
		}
	},
	"pathContext": {
		"slug": "/first-dmgt-doc"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/first-dmgt-doc.json
// module id = 461
// module chunks = 169246006831466